var currentPage = 1;
var evenOdd = 1;
var hasMore = true;
$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = LANG.aguarde;

	// $.cookieBar({
	// 	message: LANG.cookies_txt,
	// 	acceptText: LANG.cookies_btn,
	// 	fixed: true,
	// 	bottom: true,
	// 	policyButton: true,
	// 	policyText: LANG.cp_txt,
	// 	policyURL: LANG.cp_url,
	// });

	checkOathCookie();
+
	$(".btn-menu").on('click', function (e) {
		e.preventDefault();
		blockScroll(1);
		$(".menu").addClass("show");
	});
	$(".close-menu").on('click', function (e) {
		e.preventDefault();
		$(".menu").removeClass("show");
		blockScroll(0);
	});

	$(".btn-bananefactor").on('click', function (e) {
		e.preventDefault();
		$(".join-society").removeClass("completed");
	});
	$(".popup-btn a").on('click', function (e) {
		e.preventDefault();
		// $(".join-society").removeClass("completed");
		// blockScroll(1);
		$.bbq.pushState("#join-us");
		setTimeout(function () {
			$(".menu").removeClass("show");
		}, 100);

	});
	$(".close-join-society").on('click', function (e) {
		e.preventDefault();
		$(".menu").removeClass("show");
		if (!$(".join-society").hasClass("completed")) {
			$(".join-society").addClass("completed");
		}
		if ($.cookie('oath_closed') != 'true') {
			$.cookie("oath_closed", "true");
			triggerNumbersAnimations();
		}
		blockScroll(0);
	});

	// if(is_home && $(".content-text").data("url") != "")
	// {
	// 	$.getJSON( $(".content-text").data("url"), function( data ) {
	// 	// $.getJSON( $(".content-text").data("url") + currentPage + "/" + evenOdd, function( data ) {
	// 		if(data.result)
	// 		{
	// 			hasMore = data.more
	// 			$(".content-text").html(data.data);
	// 		}
	// 	  });

	// }
	var isCanada = false;
	if (CANADA == 'true') {
		isCanada = true;
		triggerNumbersAnimations();
	}
	else {
		isCanada = false;
	}


	$('.trigger-video').on('click', function () {
		$('#video-play').click();
	});

	$('#search-words').submit(function (e) {
		e.preventDefault();
		SearchName();

	});
	$("#search_btn").on('click', function (e) {
		e.preventDefault();
		SearchName();
	});
	$("#search_name").on('input', function (e) {
		if ($(this).val() != "") {
			if (!$("#clean_search").hasClass("show")) {
				$("#clean_search").addClass("show");
			}
		}
		else {
			$("#clean_search").removeClass("show");
			SearchName();
		}
	});

	$("#clean_search").on('click', function (e) {
		e.preventDefault();
		$("#search_name").val("");
		$(this).removeClass("show");
		SearchName();
	});



	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('.loading-container').fadeOut(500, function () {
			$(this).remove();
		});

		AOS.init({
			'offset': -50
		});

		$('#video-play').fancybox({
			width: '56vw',
			height: 300,
			autoSize: false,
			afterShow: appendVideoCloseBtn,
			afterClose: function () {
				$.cookie("video_closed", "true");
			}
		});
		if ($('#video-play').length && $.cookie("video_closed") != 'true' && $.cookie('oath_closed') == 'true' && !isCanada) {
			$('#video-play')[0].click();
		}
	}, 300);

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else {//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	$("#btn-join-society2").on('click', function (e) {
		e.preventDefault();
		var first_name = $.trim($("#first-name").val());
		var last_name = $.trim($("#last-name").val());
		var email = $.trim($("#society-email").val());
		// var phone = $.trim($("#society-phone").val());
		var form = $('#form-join-society');

		if (first_name == "") {
			// alert("Fill in the name.");
			$("#first-name").focus();
			form.find('#feedback').removeClass().html(LANG.fill_in_your_first_name).addClass('error').fadeIn("fast");
		}
		else if (last_name == "") {
			// alert("Fill in the email.");
			$("#last-name").focus();
			form.find('#feedback').removeClass().html(LANG.fill_in_your_last_name).addClass('error').fadeIn("fast");
		}
		else if (email == "") {
			// alert("Fill in the email.");
			$("#society-email").focus();
			form.find('#feedback').removeClass().html(LANG.fill_in_the_email).addClass('error').fadeIn("fast");
		}
		else if (!IsEmail(email)) {
			// alert("The email is not valid.");
			$("#society-email").focus();
			form.find('#feedback').removeClass().html(LANG.the_email_is_not_valid).addClass('error').fadeIn("fast");
		}
		else if (!checkPolicy(form)) {
			form.find('#feedback').removeClass().html(LANG.please_accept_the_privacy_policy).addClass('error').fadeIn("fast");
		}
		// else if(phone == "")
		// {
		// 	alert("Fill in the phone.");
		// 	$("#society-phone").focus();
		// }
		else {
			$.post($("#form-join-society").attr("action"), $("#form-join-society").serialize(), function (data, textStatus) {
				var json = JSON.parse(data);
				if (json.result) {
					$.cookie('oath', 'complete', { expires: 5259487 });
					$('#thanks-container').addClass('show');
				}
				else {
					form.find('#feedback').removeClass().html(json.message).addClass('error').fadeIn("fast");
				}
			});
		}

	});

	$('body').on('click', '#btn-join-society', function (e) {
		e.preventDefault();

		var form = $('#form-join-society');
		var fields = form.serialize();
		var action = form.attr('action');

		if (checkPolicy(form)) {
			var send = true;
			form.find('#feedback').removeClass().html('');
			form.find('.invalid').removeClass('invalid');

			if (send) {
				$.blockUI();
				$.ajax({
					url: action,
					type: 'POST',
					data: fields,
					dataType: 'json',
					success: function (r) {
						if (r.result) {
							dataLayer.push({ 'event': 'formSubmit' });
							$.cookie('oath', 'complete', { expires: 5259487 });
							$('#thanks-container').addClass('show');
						}
						else {
							form.find('#feedback').removeClass().html(r.message).addClass('error').fadeIn("fast");
						}
						$.unblockUI();
					},
					error: function (r) {
						$('#feedback').show().addClass('error').html('An error occurred...');
						$.unblockUI();
					}
				});
			}
		} else {
			$('#feedback').show().addClass('error').html(LANG.accept_privacy_policy);
			$.unblockUI();
		}
	});

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}
	function appendVideoCloseBtn() {
		$('.fancybox-content').append('<a href="javascript:;" onclick="$.fancybox.close();" class="close-btn" title="Close" aria-label="Close"></a>');
	}



	if ($('#join-us').length) {
		// $('.btn-join-us').on('click', function(){

		// 	});
		$('.close-join-society').on('click', function () {
			if ($('.join-society.completed').length) {
				$.bbq.pushState("#close");
			}
		});

		$(window).on("hashchange", function (event) {
			if (window.location.hash) {
				var $target = $('#' + decodeURIComponent($.param.fragment()));
				if ($target.length && $target.hasClass('completed')) {
					blockScroll(1);
					$target.removeClass('completed');
				}
			}
		}).trigger("hashchange");
	}


	resizeWordContainer();
	window.onresize = function () {
		resizeWordContainer();
	};
});
function checkOathCookie() {

	if ($.cookie('oath') == 'complete' || $.cookie('oath_closed') == 'true') {
		if (!$('.join-society').hasClass("completed")) {
			$('.join-society').addClass("completed");
			triggerNumbersAnimations();
		}
	}
}

function resizeWordContainer() {
	const matchesMediaQuery = window.matchMedia('(max-width:991px) and (orientation:landscape)').matches;
	if ($('.word-container').length && $(window).width() > 768 && !matchesMediaQuery) {
		var footer = $('#footer').offset();
		var wordcontainer = $('.word-container').offset();
		$('.word-container').height(footer.top - wordcontainer.top);
	}
	else {
		$('.word-container').height('unset');
	}
}

function triggerNumbersAnimations() {
	if ($('body').hasClass('ishome')) {
		var trees_cont = { val: 0 };
		var $trees_number = $('#trees-number');
		gsap.to(trees_cont, 3, {
			val: $trees_number.data('value'), onUpdate: function () {
				$trees_number.text(gsap.utils.snap(100, trees_cont.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var people_assisted = { val: 0 };
		var $homes_number = $('#people-number');
		gsap.to(people_assisted, 3, {
			val: $homes_number.data('value'), roundProps: "val", onUpdate: function () {
				$homes_number.text(gsap.utils.snap(20, people_assisted.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var school_cont = { val: 0 };
		var $school_number = $('#school-number');
		gsap.to(school_cont, 4, {
			val: $school_number.data('value'), roundProps: "val", onUpdate: function () {
				$school_number.text(gsap.utils.snap(5, school_cont.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var species_cont = { val: 0 };
		var $species_cont = $('#species-number');
		gsap.to(species_cont, 4, {
			val: $species_cont.data('value'), roundProps: "val", onUpdate: function () {
				$species_cont.text(gsap.utils.snap(5, species_cont.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var food_cont = { val: 0 };
		var $food_cont = $('#food-number');
		gsap.to(food_cont, 4, {
			val: $food_cont.data('value'), roundProps: "val", onUpdate: function () {
				$food_cont.text(gsap.utils.snap(1, food_cont.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var trees_cont1 = { val: 0 };
		var $trees_number1 = $('#trees-number1');
		gsap.to(trees_cont1, 3, {
			val: $trees_number1.data('value'), onUpdate: function () {
				$trees_number1.text(gsap.utils.snap(100, trees_cont1.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var people_assisted1 = { val: 0 };
		var $homes_number1 = $('#people-number1');
		gsap.to(people_assisted1, 3, {
			val: $homes_number1.data('value'), roundProps: "val", onUpdate: function () {
				$homes_number1.text(gsap.utils.snap(20, people_assisted1.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var school_cont1 = { val: 0 };
		var $school_number1 = $('#school-number1');
		gsap.to(school_cont1, 4, {
			val: $school_number1.data('value'), roundProps: "val", onUpdate: function () {
				$school_number1.text(gsap.utils.snap(5, school_cont1.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var species_cont1 = { val: 0 };
		var $species_cont1 = $('#species-number1');
		gsap.to(species_cont1, 4, {
			val: $species_cont1.data('value'), roundProps: "val", onUpdate: function () {
				$species_cont1.text(gsap.utils.snap(5, species_cont1.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});

		var food_cont1 = { val: 0 };
		var $food_cont1 = $('#food-number1');
		gsap.to(food_cont1, 4, {
			val: $food_cont1.data('value'), roundProps: "val", onUpdate: function () {
				$food_cont1.text(gsap.utils.snap(1, food_cont1.val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			}
		});
	}
}

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}